import { Mail } from 'lucide-react';

import { BadgeSelect } from '../../../BadgeSelect';
import { IconButtonTemplate } from '../../../../ui/buttons/IconButtonTemplate';
import { WhatsAppIcon } from '../../../../ui/icons';

import { requestDealToggleData } from '../../../../../lib/mocks/add-request-mock';
import { getInputValueWithColor } from '../../../../../utils/data';
import { useWhatsApp } from '../../../../../hooks/useWhatsApp';
import { EVENT_LOG_SUBJECTS } from '../../../../../redux/services/eventLog/eventLogApi';

export const RequestActions = ({
  request_type,
  phone = false,
  email = false,
  client_id,
  request_id,
  canEmail = true,
  handleSubmitEditing = () => {},
  handleSendReplyClick = () => {},
}) => {
  const sendWhatsApp = useWhatsApp();
  let emailTooltip = 'Emails';
  if (!canEmail) emailTooltip = 'Only the client\'s agent can email them';
  else if (!email) emailTooltip = 'Client has no email';
  const newRequestType = request_type
    ? getInputValueWithColor(
        requestDealToggleData,
        request_type,
        'request_type'
      )
    : '';

  return (
    <div className="flex flex-wrap items-center gap-7">
      {newRequestType && (
        <BadgeSelect
          key={newRequestType.value}
          item={{
            ...newRequestType,
            handleBadgeSelect: handleSubmitEditing,
          }}
        />
      )}

      <div className="flex gap-1 items-center py-0.5 px-1 w-fit bg-yellow-300 rounded">
        <IconButtonTemplate
          handleClick={() =>
            sendWhatsApp(phone, {
              subject_type: EVENT_LOG_SUBJECTS.CLIENT_REQUEST,
              subject_id: request_id,
              payload: { client_id },
            })
          }
          icon={WhatsAppIcon}
          size={16}
          tooltipText={'Open in WhatsApp'}
          disabled={!phone}
        />

        <IconButtonTemplate
          handleClick={handleSendReplyClick}
          icon={Mail}
          size={16}
          tooltipText={emailTooltip}
          disabled={!email || !canEmail}
        />

        <span className="px-1 text-xs text-blackColor">Send reply</span>
      </div>
    </div>
  );
};
